export default __webpack_public_path__ + "static/media/sa-grey.5d7d5ad8.svg";